import { type AppTranslator, type Locale } from '@/i18n'
import { type App, inject } from 'vue'
import type { AppCurrency } from '@/plugins/currency.ts'
import type { Decimal } from '@/types/decimal.ts'

const key = 'app.plugin.money-formatter'

export type MoneyFormatter = (money: Money) => string

// TODO Move money formatter type over here
export function installMoneyFormatter(
    app: App,
    translator: AppTranslator
): MoneyFormatter {
    const { locale } = translator

    const formatter = (money: Money): string => {
        return getFormatter(money.currency, locale.value)
            .format(Number(money.amount))
            .replace(/[.]0+(?=\D|$)/, '')
    }

    app.provide(key, formatter)

    return formatter
}

export function useMoneyFormatter(): MoneyFormatter {
    return inject(key) as MoneyFormatter
}

type FormatterKey = `currency-${AppCurrency}:locale-${Locale}`

const getKey = (currency: AppCurrency, locale: Locale): FormatterKey =>
    `currency-${currency}:locale-${locale}`

const formatters: Partial<Record<FormatterKey, Intl.NumberFormat>> = {}

export type Money = {
    amount: Decimal | number
    currency: AppCurrency
}

export const getFormatter = (
    currency: AppCurrency,
    locale: Locale
): Intl.NumberFormat =>
    (formatters[getKey(currency, locale)] ||= new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
    }))
